import { Tag, TagVariants } from '../../../components';
import { PlatformTaskManagedProvider } from '../../../types';

interface ManagedByTagProps {
  managedProvider: PlatformTaskManagedProvider | null;
}

export const ManagedByTag = ({ managedProvider }: ManagedByTagProps) => {
  if (managedProvider) {
    return (
      <Tag
        text={`✨ Managed by ${managedProvider.name}`}
        variant={TagVariants.IndigoGradient}
      />
    );
  }

  return null;
};
